export const CLIENT_CLIENT_REFERRAL_LIST = 'CLIENT_CLIENT_REFERRAL_LIST';
export const CLIENT_CLIENT_REFERRAL_SPOC_LIST = 'CLIENT_CLIENT_REFERRAL_SPOC_LIST';
export const CLIENT_CLIENT_REFERRAL_REJECT_REASONS = 'CLIENT_CLIENT_REFERRAL_REJECT_REASONS';
export const CLIENT_CLIENT_REFERRAL_STATUS_HISTORY = 'CLIENT_CLIENT_REFERRAL_STATUS_HISTORY';
